<template>
  <div class="c-number-input-cont">
    <div class="c-number-input-lable">
      {{ label }}
    </div>
    <div class="c-number-input">
      <div class="c-number-input-mius">
        <v-icon @click="minus()" color="primary">mdi-minus</v-icon>
      </div>
      <div class="c-number-input-text">
        {{ count }}
      </div>
      <div class="c-number-input-plus">
        <v-icon @click="plus()" color="primary">mdi-plus</v-icon>
      </div>
      <input :name="name" type="hidden" :value="count" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      required: true,
    },
    name: {
      required: true,
    },
    label: {
      required: true,
    },
    inputValue: {
      required: false,
    },
    max: {
      default: 100,
    },
    min: {
      default: 0,
    },
  },
  data() {
    return {
      count: this.inputValue ?? 0,
    };
  },
  methods: {
    plus() {
      if (this.count < this.max) {
        this.count++;
      }
    },
    minus() {
      if (this.count > this.min) {
        this.count--;
      }
    },
  },
  computed: {
    selected() {},
  },
  watch: {
    count(value) {
      this.$emit('change', { id: this.id, count: value });
    },
  },
};
</script>
<style>
.c-number-input {
  padding: 0 2px;
  padding-bottom: 2px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  overflow: hidden;
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  font-size: 16px;
  float: left;
}

.c-number-input-mius {
  float: left;
  width: 32px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  color: #0078cc;
  font-weight: bold;
}

.c-number-input-text {
  float: left;
  width: 32px;
  height: 32px;
  text-align: center;
  line-height: 34px;
}

.c-number-input-plus {
  float: left;
  width: 32px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  color: #0078cc;
  font-weight: bold;
}
.c-number-input-lable {
  line-height: 38px;
  padding-right: 10px;
  float: left;
  font-size: 16px;
}
.c-number-input-cont {
  display: block;
  width: 100%;
  overflow: hidden;
  margin-bottom: 10px;
}
</style>
